/* eslint-disable jsx-a11y/alt-text */

/* eslint-disable @next/next/no-img-element */

/*
 * Image <next/image> only support image local and image from config in file next.config.ts
 */
import { FC, useEffect, useState } from "react";
import { Link } from "@/components/Link/Link";
import { WebInfoData } from "@/pages/api/getInfoUrl";

interface Props {
  url: string;
}

export const EmbedCard: FC<Props> = ({ url }) => {
  const parsedUrl = new URL(url);
  const host = parsedUrl.host;

  const [data, setData] = useState<WebInfoData>({ title: "", imageUrl: "", description: "" });

  useEffect(() => {
    const getData = async () => {
      const res = await fetch(window.origin + "/api/getInfoUrl?linkData=" + url);
      const data = (await res.json()) as WebInfoData;
      setData(data);
    };

    void getData();
  }, [url]);

  return (
    <Link
      href={url}
      className="my-4 flex h-[120px] items-center rounded border border-[#5c93bb33] bg-white text-base !text-black !no-underline"
      target="_blank"
    >
      <div className="w-full p-3 sm:p-5">
        <div className="line-clamp-2 font-bold">{data.title}</div>
        <div className="line-clamp-1 text-sm">{data.description}</div>
        <div className="mt-2 flex items-center text-sm">
          <img alt="" className="emoji mr-2" src={`http://www.google.com/s2/favicons?domain=${host}`} />
          <span className="leading-5">{host}</span>
        </div>
      </div>
      {data.imageUrl ? (
        <div className="h-full max-w-[230px]">
          <img className="emoji m-0 !ml-auto h-full w-full object-cover sm:w-auto" src={data.imageUrl} />
        </div>
      ) : null}
    </Link>
  );
};
